import { ButtonDotsLoader } from '../ButtonDotsLoader'
import clsx from 'clsx'
import getTestId from 'utils/getTestId'

import style from '../Button.module.css'

export type TButton = {
  className?: string
  style?: React.CSSProperties
  disabled?: boolean
  loading?: boolean
  size?: 'normal' | 'medium'
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  dataTestId?: string
  type?: 'submit' | 'button'
  title?: string
}

function CommonButton({
  disabled = false,
  loading = false,
  className,
  style: styleProp,
  onClick = () => {},
  size = 'medium',
  children,
  dataTestId = 'button',
  type = 'button',
  title,
}: React.PropsWithChildren<TButton>) {
  return (
    <button
      type={type}
      disabled={disabled}
      title={title}
      style={styleProp}
      className={clsx(
        style.default,
        {
          [style.normal]: size === 'normal',
          [style.medium]: size === 'medium',
        },
        className
      )}
      onClick={onClick}
      data-test-id={getTestId(dataTestId)}
    >
      {loading ? (
        <span className={style.loadingWrap}>
          <span className={style.loadingLabelReserve}>{children}</span>
          <span className={style.loaderOverlay} aria-hidden>
            <ButtonDotsLoader />
          </span>
        </span>
      ) : (
        children
      )}
    </button>
  )
}

export default CommonButton
